import React from 'react'
import { TypesHelper } from 'SRC/utils'
import PropTypes from 'prop-types'
import { isJsonString } from 'src/utils/Utils'
import config from 'SRC/config/config.yaml'

const renderCompatibilitiesForSingleBrand = (compatibilities, count) => {
  return [
    compatibilities[0] && compatibilities[0].brand
      ? `${compatibilities[0].brand.name} ${compatibilities[0].product
        ? ` - ${compatibilities[0].product.model}`
        : ''}` : null,
    count > 1 ? ` (+${count - 1})` : ''
  ]
}

const renderCompatibilitiesForMultipleBrands = (compatibilityBrands, restBrands) => {
  const restBrandsCount = compatibilityBrands.slice(0, 5).reduce((acc, curr) => {
    if (!curr.logo) acc++
    return acc
  }, 0)

  return [
    compatibilityBrands.slice(0, 5).map(brand => {
      if (brand.logo) {
        return <img src={`${config.mediaCDN}${brand.logo}`} alt={brand.name} width={20}
          style={{ marginRight: 2 }} />
      } else {
        restBrands++
        return null
      }
    }),
    restBrandsCount ? ` +${restBrandsCount}` : ''
  ]
}

const renderCompatibilities = value => {
  const count = value.compatibilitiesCount
  const countBrands = value.compatibilityBrandsCount
  const compatibilities = value.compatibilities
  const compatibilityBrands = value.compatibilityBrands

  const categoryText = compatibilities[0] && compatibilities[0].category && compatibilities[0].category.compatibilityTitle
    ? compatibilities[0].category.compatibilityTitle
    : compatibilities[0].category.title
  let yearsText = ''
  let restBrands = countBrands <= 5 ? 0 : countBrands - 5

  if (count > 1) {
    yearsText = 'Za više godišta'
  } else {
    if (count === 1) {
      const years = compatibilities[0].years && compatibilities[0].years.length
        ? compatibilities[0].years.map(y => Number(y)) : null
      if (years) {
        const yMin = Math.min(...years)
        const yMax = Math.max(...years)

        yearsText = yMin === yMax ? yMin : `${yMin} - ${yMax}`
      }
    }
  }

  return <ul>
    <li>
      <b>Za:</b> {categoryText}
    </li>
    <li style={{ maxHeight: 20 }}>
      {countBrands > 1
        ? renderCompatibilitiesForMultipleBrands(compatibilityBrands, restBrands)
        : countBrands === 1
          ? renderCompatibilitiesForSingleBrand(compatibilities, count)
          : null}
    </li>
    <li>{yearsText}</li>
  </ul>
}

const renderServiceAndServiceType = (service, serviceType) => {
  return <ul>
    <li>{service.name}</li>
    <li>{serviceType.name}</li>
  </ul>
}

const renderDescription = description => {
  if (!description || !description.length) return ''

  return <p>{description.length > 110 ? `${description.slice(0, 110)}...` : description}</p>
}

export const GridView = ({
  specs,
  compatibilities,
  compatibilityBrands,
  compatibilitiesCount,
  compatibilityBrandsCount,
  service,
  serviceType,
  description
}) => {
  const hasSpecs = TypesHelper.isNotEmptyArray(specs)

  return (
    <div className={`oglasi-item-tekst-tekst ${hasSpecs || compatibilities.length || (service && serviceType)
      ? `` : `oglasi-item-tekst-tekst_no-specs`}`}>
      {
        hasSpecs
          ? <ul>
            {
              specs.map((item, index) => {
                if (item) {
                  return [
                    <li key={index}>
                      <b>{item.title}</b>:&nbsp;
                      {isJsonString(item.value) && Array.isArray(JSON.parse(item.value))
                        ? JSON.parse(item.value).join(', ') : item.value}
                      {item.measure ? item.measure : ''}
                    </li>,
                    '\n'
                  ]
                } else {
                  return ''
                }
              })
            }
          </ul>
          : compatibilities && compatibilities.length
            ? renderCompatibilities({
              compatibilities,
              compatibilityBrands,
              compatibilitiesCount,
              compatibilityBrandsCount
            })
            : service && serviceType ? renderServiceAndServiceType(service, serviceType) : renderDescription(description)
      }
    </div>
  )
}

GridView.propTypes = {
  specs: PropTypes.arrayOf(PropTypes.object).isRequired,
  compatibilities: PropTypes.arrayOf(PropTypes.object),
  compatibilityBrands: PropTypes.array,
  compatibilitiesCount: PropTypes.number,
  compatibilityBrandsCount: PropTypes.number,
  service: PropTypes.shape({
    name: PropTypes.string.isRequired
  }),
  serviceType: PropTypes.shape({
    name: PropTypes.string.isRequired
  }),
  description: PropTypes.string
}

GridView.defaultProps = {
  specs: []
}
